module.exports = __webpack_public_path__ + "static/img/1a.510f7178.png";